export const defineAll =
  <T extends string>() =>
  <U extends readonly T[]>(
    ...values: U & ([T] extends [U[number]] ? unknown : ['Missing values'])
  ) =>
    values
